import { useCallback, useLayoutEffect, useRef } from "react";
import useResizeObserver from "@react-hook/resize-observer";
const useHeaderSectionObserver = (colId, part, onWidth) => {
  const ref = useRef(null);
  const reportWidth = useCallback(
    (width) => {
      onWidth(colId, part, Math.round(width));
    },
    [colId, onWidth, part]
  );
  useLayoutEffect(() => {
    if (ref.current) {
      reportWidth(ref.current.getBoundingClientRect().width);
    }
  }, [reportWidth]);
  useResizeObserver(ref, ({ contentRect: { width } }) => reportWidth(width));
  return ref;
};
export default useHeaderSectionObserver;
